import * as React from 'react'
export default () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="18" height="19" viewBox="0 0 18 19">
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M3.906 18.25H.273V6.57h3.633v11.68zM2.11 4.969a2.028 2.028 0 0 1-1.484-.625A2.028 2.028 0 0 1 0 2.859c0-.573.208-1.067.625-1.484A2.028 2.028 0 0 1 2.109.75c.573 0 1.068.208 1.485.625.416.417.625.911.625 1.484s-.209 1.068-.625 1.485a2.028 2.028 0 0 1-1.485.625zM17.5 18.25h-3.633v-5.703c0-.938-.078-1.615-.234-2.031-.287-.703-.847-1.055-1.68-1.055s-1.42.312-1.758.937c-.26.47-.39 1.16-.39 2.07v5.782H6.21V6.57h3.476v1.602h.04c.26-.52.677-.95 1.25-1.29.625-.416 1.354-.624 2.187-.624 1.693 0 2.878.534 3.555 1.601.52.86.781 2.188.781 3.985v6.406z"
    />
  </svg>
)